export default __webpack_public_path__ + "static/media/621429.d6fd959d.png";